import {useMutation, useQueryClient} from "@tanstack/react-query";
import {useModal} from "../../../../../hooks";
import {AxiosError} from "axios";
import {updateProductDetailImageEx} from "../../../../../api/product/ProductExApi";
import {saveTaxEndDate} from "../../../../../api/order/DeadlineApi";
import {DeadlineFilterItemType} from "../interface";


export const useSaveTaxEndDate = () => {
    const {handleModal} = useModal();
    const qc = useQueryClient()

    const {mutate} = useMutation({
        mutationFn: (data: DeadlineFilterItemType) => saveTaxEndDate(data),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "저장되었습니다",
                type: "alert",
            });

            qc.invalidateQueries({queryKey: ["readTaxEndDate"]})
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
